// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login.css */

.login-container {
    max-width: 400px;
    margin: 10% auto;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.login-heading {
    font-size: 1.5rem;
    text-align: center;
    margin-bottom: 20px;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
}

.form-group input {
    width: 100%;
    padding: 10px;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.form-group input:focus {
    outline: none;
    border-color: #4E3B31;
    /* Blue border color on focus */
}

.error-message {
    color: red;
    font-size: 0.9rem;
    margin-top: 5px;
}

.login__button-submit {
    margin-top: 10px;
    width: 100%;
    padding: 7px;
    font-size: 1rem;
    background: linear-gradient(to right, #6d8df5, #1b2af8);
    color: #fff;
    border: none;
    border-radius: 25px;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.3s ease;
}

.login__button-submit:hover {
    background: linear-gradient(to right, #6d8df5, #1b2af8);
    transform: scale(1.05);
}

.register-button {
    margin-top: 10px;
    width: 100%;
    padding: 7px;
    font-size: 1rem;
    background: linear-gradient(to right, #f56d84, #fc2525);
    color: #fff;
    border: none;
    border-radius: 25px;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.3s ease;
}

.register-button:hover {
    background: linear-gradient(to right, #f56d84, #fc2525);
    transform: scale(1.05);
}

.form-group label {
    font-weight: 500 !important;
    font-size: 0.85rem;
}

.custom-input {
    border-radius: 0.25rem;
    padding: 0.25rem 0.5rem !important;
    font-size: 0.775rem;
    height: auto;
}

.form-content {
    position: relative;
    z-index: 2;
    background-color: rgba(255, 255, 255, 0.8) !important;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    margin-top: 100px;
}



`, "",{"version":3,"sources":["webpack://./src/style/Login.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,uCAAuC;AAC3C;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,uDAAuD;IACvD,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,2DAA2D;AAC/D;;AAEA;IACI,uDAAuD;IACvD,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,uDAAuD;IACvD,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,2DAA2D;AAC/D;;AAEA;IACI,uDAAuD;IACvD,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,kCAAkC;IAClC,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,qDAAqD;IACrD,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,iBAAiB;AACrB","sourcesContent":["/* Login.css */\r\n\r\n.login-container {\r\n    max-width: 400px;\r\n    margin: 10% auto;\r\n    padding: 20px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n    background-color: #fff;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.login-heading {\r\n    font-size: 1.5rem;\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.form-group {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.form-group label {\r\n    display: block;\r\n    margin-bottom: 5px;\r\n    font-weight: bold;\r\n}\r\n\r\n.form-group input {\r\n    width: 100%;\r\n    padding: 10px;\r\n    font-size: 1rem;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n}\r\n\r\n.form-group input:focus {\r\n    outline: none;\r\n    border-color: #4E3B31;\r\n    /* Blue border color on focus */\r\n}\r\n\r\n.error-message {\r\n    color: red;\r\n    font-size: 0.9rem;\r\n    margin-top: 5px;\r\n}\r\n\r\n.login__button-submit {\r\n    margin-top: 10px;\r\n    width: 100%;\r\n    padding: 7px;\r\n    font-size: 1rem;\r\n    background: linear-gradient(to right, #6d8df5, #1b2af8);\r\n    color: #fff;\r\n    border: none;\r\n    border-radius: 25px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease, transform 0.3s ease;\r\n}\r\n\r\n.login__button-submit:hover {\r\n    background: linear-gradient(to right, #6d8df5, #1b2af8);\r\n    transform: scale(1.05);\r\n}\r\n\r\n.register-button {\r\n    margin-top: 10px;\r\n    width: 100%;\r\n    padding: 7px;\r\n    font-size: 1rem;\r\n    background: linear-gradient(to right, #f56d84, #fc2525);\r\n    color: #fff;\r\n    border: none;\r\n    border-radius: 25px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease, transform 0.3s ease;\r\n}\r\n\r\n.register-button:hover {\r\n    background: linear-gradient(to right, #f56d84, #fc2525);\r\n    transform: scale(1.05);\r\n}\r\n\r\n.form-group label {\r\n    font-weight: 500 !important;\r\n    font-size: 0.85rem;\r\n}\r\n\r\n.custom-input {\r\n    border-radius: 0.25rem;\r\n    padding: 0.25rem 0.5rem !important;\r\n    font-size: 0.775rem;\r\n    height: auto;\r\n}\r\n\r\n.form-content {\r\n    position: relative;\r\n    z-index: 2;\r\n    background-color: rgba(255, 255, 255, 0.8) !important;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n    margin-top: 100px;\r\n}\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
